var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2967,
    cy: 40.2967,
    r: 37.7782,
    fill: "#D7D4F8",
    stroke: "#845BB3",
    strokeWidth: 5.03709
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2039 50.7438C52.1622 51.4938 51.835 52.1993 51.2893 52.7154C50.7437 53.2315 50.0211 53.5191 49.27 53.5191H31.3229C30.5718 53.5191 29.8492 53.2315 29.3036 52.7154C28.7579 52.1993 28.4307 51.4938 28.389 50.7438L27.2467 30.1757C27.2245 29.7768 27.284 29.3775 27.4213 29.0023C27.5587 28.6272 27.7712 28.2839 28.0457 27.9937C28.3202 27.7034 28.6511 27.4721 29.0181 27.3141C29.385 27.156 29.7803 27.0744 30.1799 27.0743H50.413C50.8126 27.0743 51.2081 27.1558 51.5751 27.3138C51.9421 27.4719 52.2731 27.7031 52.5477 27.9934C52.8223 28.2837 53.0348 28.6269 53.1722 29.0022C53.3097 29.3774 53.3691 29.7767 53.3469 30.1757L52.2039 50.7438ZM47.8215 35.7269C48.4238 35.3302 48.5751 34.5435 48.0808 34.0315C47.2424 33.1659 46.2624 32.4499 45.1829 31.9145C43.6843 31.1711 42.0382 30.7727 40.3655 30.7487C38.6913 30.7211 37.0322 31.068 35.5092 31.7639C34.4112 32.2655 33.4064 32.95 32.5379 33.7884C32.0259 34.2849 32.1485 35.0753 32.7369 35.4911L35.9044 37.7286C36.4921 38.1444 37.3207 38.01 37.9297 37.6221C38.0872 37.5232 38.2508 37.4344 38.4196 37.3562C38.9605 37.1094 39.547 36.9785 40.1415 36.972L42.6339 34.1064C42.7617 33.9593 42.9427 33.869 43.1371 33.8554C43.2333 33.8487 43.3299 33.8609 43.4214 33.8915C43.513 33.9221 43.5975 33.9704 43.6704 34.0337C43.7432 34.097 43.8029 34.174 43.8459 34.2603C43.889 34.3467 43.9146 34.4406 43.9214 34.5369C43.9281 34.6331 43.9159 34.7298 43.8853 34.8213C43.8547 34.9128 43.8064 34.9974 43.7431 35.0702L41.8097 37.2923C42.0714 37.4009 42.3215 37.5357 42.556 37.6948C43.151 38.1011 43.9737 38.2605 44.5761 37.8638L47.8215 35.7269Z",
    fill: "#845BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.a05731f9e01efe1fb9009a80a88a58b6.svg";
export { ForwardRef as ReactComponent };